var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5846 15.8182C25.5846 16.1891 25.6851 16.5498 25.8709 16.8636H15.2727C14.7302 16.8636 14.21 17.0791 13.8264 17.4627C13.4428 17.8463 13.2273 18.3666 13.2273 18.9091C13.2273 19.4516 13.4428 19.9718 13.8264 20.3554C14.21 20.739 14.7302 20.9545 15.2727 20.9545L30.7273 20.9545L30.7298 20.9545C31.1336 20.9525 31.5278 20.831 31.8627 20.6053C32.197 20.38 32.4573 20.061 32.6108 19.6882C32.7668 19.3162 32.8093 18.9064 32.733 18.5103C32.6565 18.1135 32.4643 17.7483 32.1805 17.4606L32.1781 17.4583L29.0872 14.3674C28.7024 13.9826 28.1805 13.7664 27.6364 13.7664C27.3669 13.7664 27.1001 13.8195 26.8512 13.9226C26.6023 14.0257 26.3761 14.1768 26.1855 14.3674C25.995 14.5579 25.8439 14.7841 25.7408 15.033C25.6377 15.2819 25.5846 15.5487 25.5846 15.8182ZM14.1373 23.3947C13.8031 23.6199 13.5428 23.939 13.3892 24.3116C13.2332 24.6836 13.1907 25.0935 13.267 25.4897C13.3435 25.8865 13.5357 26.2517 13.8195 26.5394L13.8219 26.5417L16.9114 29.6312C16.9117 29.6315 16.912 29.6318 16.9122 29.6321C17.1022 29.8234 17.3281 29.9752 17.577 30.0789C17.8263 30.1828 18.0936 30.2362 18.3636 30.2362C18.6337 30.2362 18.901 30.1828 19.1503 30.0789C19.3989 29.9754 19.6246 29.8237 19.8144 29.6327C20.0055 29.4429 20.1572 29.2171 20.2607 28.9684C20.3646 28.7192 20.4181 28.4518 20.4181 28.1818C20.4181 27.9118 20.3646 27.6444 20.2607 27.3952C20.2235 27.3057 20.18 27.2193 20.1307 27.1364H30.7273C31.2698 27.1364 31.79 26.9209 32.1736 26.5373C32.5572 26.1537 32.7727 25.6334 32.7727 25.0909C32.7727 24.5484 32.5572 24.0281 32.1736 23.6446C31.79 23.261 31.2698 23.0455 30.7273 23.0455L15.2727 23.0454L15.2702 23.0455C14.8664 23.0475 14.4722 23.169 14.1373 23.3947ZM13.8331 8.28075C16.5465 6.46771 19.7366 5.5 23 5.5C27.3761 5.5 31.5729 7.23839 34.6673 10.3327C37.7616 13.4271 39.5 17.6239 39.5 22C39.5 25.2634 38.5323 28.4535 36.7192 31.1669C34.9062 33.8803 32.3293 35.9952 29.3143 37.244C26.2993 38.4929 22.9817 38.8196 19.781 38.183C16.5803 37.5463 13.6403 35.9748 11.3327 33.6673C9.02518 31.3597 7.45371 28.4197 6.81705 25.219C6.18039 22.0183 6.50715 18.7007 7.756 15.6857C9.00484 12.6707 11.1197 10.0938 13.8331 8.28075Z",
    fill: "url(#paint0_linear_24786_52073)",
    stroke: "url(#paint1_radial_24786_52073)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4988 44.0699C51.7382 38.133 47.2604 30.1044 42.8225 23.5728C41.6046 21.7946 39.797 21.0101 38 21C36.2031 21.0101 34.3955 21.7912 33.1776 23.5728C28.7423 30.1044 24.2618 38.133 21.5013 44.0699C19.7688 47.4245 22.7557 52.3279 26.952 52.589C34.3074 53.137 41.6926 53.137 49.0481 52.589C53.2437 52.3279 56.2313 47.4245 54.4988 44.0699Z",
    fill: "url(#paint2_linear_24786_52073)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4988 44.0699C51.7382 38.133 47.2604 30.1044 42.8225 23.5728C41.6046 21.7946 39.797 21.0101 38 21C36.2031 21.0101 34.3955 21.7912 33.1776 23.5728C28.7423 30.1044 24.2618 38.133 21.5013 44.0699C19.7688 47.4245 22.7557 52.3279 26.952 52.589C34.3074 53.137 41.6926 53.137 49.0481 52.589C53.2437 52.3279 56.2313 47.4245 54.4988 44.0699Z",
    fill: "url(#paint3_radial_24786_52073)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24786_52073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2915 30.0783C40.1892 33.3576 40.0874 36.6366 39.986 39.9154C39.9631 40.4335 39.7438 40.9227 39.3739 41.2812C39.0039 41.6396 38.5117 41.8396 37.9998 41.8396C37.4879 41.8396 36.9957 41.6396 36.6258 41.2812C36.2558 40.9227 36.0365 40.4335 36.0136 39.9154C35.9122 36.6361 35.8104 33.3571 35.7081 30.0783C35.6689 29.0018 36.6943 28.0901 37.9998 28.0908C39.3054 28.0915 40.3307 29.0025 40.2915 30.0783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 47.6386C37.5684 47.6386 37.1466 47.509 36.7879 47.2661C36.4291 47.0232 36.1495 46.6781 35.9844 46.2742C35.8193 45.8703 35.7761 45.426 35.8603 44.9972C35.9444 44.5685 36.1522 44.1747 36.4573 43.8656C36.7624 43.5565 37.1511 43.346 37.5742 43.2607C37.9974 43.1754 38.436 43.2192 38.8346 43.3865C39.2332 43.5538 39.5739 43.837 39.8136 44.2005C40.0533 44.564 40.1813 44.9913 40.1813 45.4284C40.1813 46.0146 39.9514 46.5767 39.5423 46.9912C39.1332 47.4057 38.5784 47.6386 37.9998 47.6386Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52073",
    x: 13,
    y: 13,
    width: 50,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52073",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24786_52073",
    x: 35.707,
    y: 28.0908,
    width: 5.58594,
    height: 20.5477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52073",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52073",
    x1: 6,
    y1: 5,
    x2: 23,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.15384 -11.3462) rotate(55.5392) scale(40.4434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52073",
    x1: 21,
    y1: 21,
    x2: 36.4108,
    y2: 53.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 21) scale(34 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskRates);
export default __webpack_public_path__ + "static/media/riskRates.1799949386e1c4a74393621b140022d3.svg";
export { ForwardRef as ReactComponent };